import axios from 'axios'

/* Make the backend and frontend base url available throughout the app */
window.BACKEND_LOGIN_URL = process.env.BACKEND_LOGIN_URL;
window.BACKEND_URL = process.env.BACKEND_URL;
window.FRONTEND_URL = window.location.origin;

export const AXIOS = axios.create({
  baseURL: window.location.origin,
  headers: {
    'Access-Control-Allow-Origin': FRONTEND_URL
  }
});



// WEBPACK FOOTER //
// ./src/core/http-commons.js